import React, { Component } from 'react';
import ServicesComponent from '../../_Componants/Services/Services';

class Services extends Component{
    render(){
        return (
            <div>
                <ServicesComponent/>
            </div>
        )
    }
}

export default Services;